import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaUserClock } from "react-icons/fa";
import { MdLockReset, MdLockClock  } from "react-icons/md";

function Home4() {

    return(
        <>
        <Container fluid className="bc-blue300">
            <Container>
            <Row > 
                <Col className="home-about-description">
                 <div className="dreamit-section-title"><h4 style={{ fontSize: "2rem", marginBottom: "3rem"}}>Vesting</h4></div>
                 
                    <Row className="align-items-stretch">
                        <Col xs={12} md={4} className="mb-4 d-flex">
                            <div className="card br-teal101 bg-transparent mb-5 flex-fill d-flex flex-column">
                                <div className="reward-icon text-orange150 text-center mb-3"><FaUserClock /></div>
                                <div className="card-body ">
                                    <div className="item-label fs-9">Team Vesting</div>
                                    <div className="item-tokens text-blue100 fs-8"> FONTANA tokens for the team will be released 10% a year up to 7 years and after 7 years Vesting will be over.</div>
                                </div>
                            </div>
                        </Col>
                        <Col xs={12} md={4} className="mb-4 d-flex">
                            <div className="card br-teal101 bg-transparent mb-5 flex-fill d-flex flex-column">
                                <div className="reward-icon text-aqua150 text-center mb-3"><MdLockClock  /></div>
                                <div className="card-body ">
                                    <div className="item-label fs-9">Project Vesting</div>
                                    <div className="item-tokens text-blue100 fs-8">Individual project rules will specify how FONTANA tokens are vested.</div>
                                </div>
                            </div>
                        </Col>
                        <Col xs={12} md={4} className="mb-4 d-flex">
                            <div className="card br-teal101 bg-transparent mb-5 flex-fill d-flex flex-column">
                                <div className="reward-icon text-pink150 text-center mb-3"><MdLockReset /></div>
                                <div className="card-body ">
                                    <div className="item-label fs-9 ">Buyback Vesting</div>
                                    <div className="item-tokens text-blue100 fs-8">Eco system will buy back FONTANA tokens from the supply and vest them. Buybacks vested for specified periods.</div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    
                </Col>
            </Row>
            </Container>
        </Container>
        
        
        
        </>

    );


}
export default Home4;